import $ from "/srv/www/n/ndo-nederland.nl/vhosts/www/htdocs/wp-content/plugins/wp-soup-framework/node_modules/jquery";

$(document).ready(function() {
    //
    $(".review .related-pages .related-page-card .wrapper a").attr("href", " ");
    $(".review .related-pages .related-page-card .wrapper a").click(function( evt ) {
        evt.preventDefault();
     });

     //Change Langauge switch url if contains CMS in href

     $('.trp-ls-shortcode-language a').each(function(){
        this.href = this.href.replace('en/cms', 'en');
    });
});
